import CancelIcon from '@mui/icons-material/Cancel';
import RoundBox from '../RoundBox/RoundBox';
import { Text } from '../../helpers';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const InvoiceFailed = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <>
            <RoundBox
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    alignItems: 'center',
                    marginTop: '4vh',
                    padding: '12px'
                }}>
                <>
                    <CancelIcon fontSize="large" style={{ fill: 'red' }} />
                    <Text
                        i={t('signingNotCompleted')}
                        fontWeight="600"
                        color="red"
                        style={{
                            textAlign: 'center'
                        }}
                    />
                </>
            </RoundBox>
        </>
    );
};

export default InvoiceFailed;
